import React from 'react';

export const AmountInputContext = React.createContext({
	onSelectYes: () => {},
});
